<template>
    <form @submit.prevent="handleSubmit" :class="'form' + (theme !== '' ? ' form--' + theme : '')" novalidate>
        <input type="hidden" name="token" :value="$route.params.token" readonly v-if="$route.params.token" />

        <div class="form-fieldset">
            <div class="form-group" :class="{ 'has-error': submitted && $v.form.email.$error, 'has-success': submitted && !$v.form.email.$error }">
                <label class="u-sr-only" for="login-email">E-mailadres</label>
                <input type="email" v-model="form.email" id="login-email" name="emailadres" class="form-control" placeholder="Vul hier je e-mailadres in" />
                <div v-if="submitted && $v.form.email.$error" class="form-validation">
                    <span v-if="!$v.form.email.required">E-mailadres is verplicht</span>
                    <span v-if="!$v.form.email.email">E-mailadres is ongeldig</span>
                </div>
            </div>

            <div class="form-group" :class="{ 'has-error': submitted && $v.form.password.$error, 'has-success': submitted && !$v.form.password.$error }">
                <label for="login-password" class="u-sr-only">Wachtwoord</label>
                <input type="password" v-model="form.password" id="login-password" name="wachtwoord" class="form-control" placeholder="Vul hier je wachtwoord in" />
                <div v-if="submitted && $v.form.password.$error" class="form-validation">
                    <span v-if="!$v.form.password.required">Wachtwoord is verplicht</span>
                </div>
            </div>
        </div>

        <div class="g-cols:1 g-cols:1/auto>sm || g-gap:1-xs || u-text-left || align-items-center">
            <p class="form-text"><router-link class="form-link" to="/forgot-password">Wachtwoord vergeten?</router-link> of <router-link class="form-link" to="/register">Registreren</router-link></p>

            <button type="submit" class="[ c-btn c-btn--info ] form-submit-btn" :disabled="status.loggingIn">
                <span v-show="status.loggingIn"><spinner/></span>
                <span v-show="!status.loggingIn">Inloggen</span>
                <svg v-show="!status.loggingIn" xmlns="http://www.w3.org/2000/svg" width="15.589" height="12.389" viewBox="0 0 15.589 12.389">
                    <g fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2">
                        <path d="M1 6.166h12.875"/>
                        <path d="M8.15 1.4l6.438 4.794-6.438 4.8" stroke-linejoin="round"/>
                        <path d="M8.15 1.399l6.438 4.795-6.437 4.8" stroke-linejoin="round"/>
                    </g>
                </svg>
            </button>
        </div>
    </form>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import { required, email } from 'vuelidate/lib/validators';
    import normalizeFormData from '../../helpers/normalizeFormData';
    import * as ls from '../../helpers/localStorage';
    import Spinner from '../Spinner.vue';

    export default {
        name: 'LoginForm',
        components: { Spinner },
        data () {
            return {
                form: {
                    password: '',
                    email: ls.get('account:email'),
                },
                submitted: false,
            };
        },
        props: {
            theme: {
                type: String,
                default: 'light',
            },
        },
        validations: {
            form: {
                password: { required },
                email: { required, email },
            },
        },
        computed: {
            ...mapState('account', ['status']),
        },
        methods: {
            ...mapActions('account', ['login']),
            async handleSubmit (e) {
                console.log('LoginForm: handleSubmit');

                this.submitted = true;

                // validate the form
                this.$v.form.$touch();

                // if its still pending or an error is returned do not submit
                if (this.$v.form.$pending || this.$v.form.$error) return;

                // normalize form data
                const data = normalizeFormData(e.target);

                // login
                await this.login(data);

                // trigger user
                // this.$store.dispatch('account/user');
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/_essentials.scss";

    .form-text {
        color: $brand-primary;
        font-size: rem(15);
        margin-bottom: 0;
        margin-left: grid(1, sm);
    }

    .form-link {
        text-decoration: underline;
    }

    .form-submit-btn {
        @include media-breakpoint-down(xsl) {
            justify-self: center;
        }
    }
</style>
